__turbopack_context__.v({
  "jumpText": "uxreqG_jumpText",
  "link": "uxreqG_link",
  "nav": "uxreqG_nav",
});
